import i18n from './../../../shared/i18n';
import BaseModel, {defineTranslatableProperties} from "../../../core/components/input-widget/BaseModel";

export default class AudienceSearch extends BaseModel {
  name = null;

  rules = {};

  attributeLabels = {
    name: i18n.t('Audience'),
  };

  attributePlaceholders = this.attributeLabels;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  toJSON() {
    let data = super.toJSON();
    return data;
  }
}

defineTranslatableProperties(AudienceSearch);
